/// <amd-module name="Release/Landing/Constants" />
export namespace RightPanePivotBarKeys {
    export const Releases = "releases";
    export const Deployments = "deployments";
    export const Analytics = "analytics";
}

export namespace LeftPanePivotBarKeys {
    export const NavigationKey = "view";
    export const Active = "mine";
    export const All = "all";
    export const Deleted = "deleted";
}

export namespace QueryParamKeys {
    export const DefinitionIdKey = "definitionId";
    export const PathKey = "path";
}

export namespace MessageBarKeys {
    export const HubSuccess = "release-landing-hub-success-message-bar";
    export const HubError = "release-landing-hub-error-message-bar";
    export const SignalR = "release-landing-hub-signalR-message-bar";
}

export const RmServiceInstanceId = "0000000d-0000-8888-8000-000000000000";

export namespace ReleasesViewCanvasConstants {
    export const EnvironmentNodeHeight: number = 24;
    export const EnvironmentNodeWidthLarge: number = 96; // has to be in-sync with .pending-approval-container
    export const EnvironmentNodeWidthSmall: number = 42;
    export const EnvironmentNodeRightMargin: number = 8;
}

export namespace ActiveReleaseColumnKeys {
    export const ActiveReleaseNameKey: string = "active-release-name-column";
    export const ActiveReleaseEnvironmentsKey: string = "active-release-environments-column";
    export const ActiveReleaseCreatedKey: string = "active-release-created-column";
    export const ActiveReleaseDescriptionKey: string = "active-release-description-column";
    export const ActiveReleaseTagsKey: string = "active-release-tags-column";
    export const ActiveReleaseDefinitionNameKey: string = "active-release-definition-name-column";
}

export namespace ActiveReleasesMenuItemKeys {
    export const OpenMenuItemKey = "open-release-menu-item";
    export const OpenInNewTabMenuItemKey = "open-newtab-release-menu-item";
    export const StartMenuItemKey = "start-release-menu-item";
    export const RetainReleaseMenuItemKey = "retain-release-menu-item";
    export const AbandonReleaseMenuItemKey = "abandon-release-menu-item";
    export const DeleteReleaseMenuItemKey = "delete-release-menu-item";
    export const UndeleteReleaseMenuItemKey = "undelete-release-menu-item";
}

export namespace CreateReleaseEnvironmentNodeConstants {
    export const compactEnvironmentNodeHeight: number = 30;
    export const compactEnvironmentNodeWidth: number = 108;
    export const gridCellWidth: number = 5;
    export const gridCellHeight: number = 5;
    export const createReleaseEnvironmentCanvasVerticalMargin: number = 35;
    export const createReleaseEnvironmentCanvasVerticalMarginSmall: number = 20;
    export const createReleaseEnvironmentCanvasHorizontalMargin: number = 60;
    export const createReleaseEnvironmentCanvasHorizontalMarginSmall: number = 30;
    export const createReleaseEnvironmentCanvasLeftMargin: number = 60;
}

export namespace NamedStoreEvents {
    export const Pileline_Renamed_Moved_Event = "Pipeline_Renamed_Moved_Event";
}

export namespace ReleaseLandingCommandBarConstants {
    export const moreButtonId = "release-landing-command-bar-menu-button"
}